<div role="status" aria-live="polite" aria-atomic="true">
    @if (isLoading) {
        <span class="sr-only">Loading</span>
        <div class="loader-overlay">
            <fa-icon class="loader" [icon]="icons.spinner" size="4x" [animation]="'spin'" aria-hidden="true"></fa-icon>
        </div>
    }
</div>
